import { render, staticRenderFns } from "./GroupsModerationScreen.vue?vue&type=template&id=11f83aa2&scoped=true&"
import script from "./GroupsModerationScreen.vue?vue&type=script&lang=js&"
export * from "./GroupsModerationScreen.vue?vue&type=script&lang=js&"
import style0 from "./GroupsModerationScreen.vue?vue&type=style&index=0&id=11f83aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f83aa2",
  null
  
)

export default component.exports